import { useI18n } from '../../i18n';
import { BADGE_XS } from './badgeSize';

/**
 * #569 — the result of the birth-date check of a claim, for the reviewer.
 * "Matched" does not prove the person (#576): the reviewer still decides.
 * "Not checked": a claim from before the check, or a claim after several
 * wrong birth dates on the record, when the server stops the comparison.
 * The public text does not say the number (the bundle is public).
 */
export default function ClaimCheckBadge({ verified }: { verified: boolean }) {
  const { t } = useI18n();
  return verified
    ? <span data-testid="claim-check" data-verified="true" className={`badge badge-green ${BADGE_XS}`}>{t.teams.birthDateMatched}</span>
    : <span data-testid="claim-check" data-verified="false" className={`badge badge-amber ${BADGE_XS}`}>{t.teams.birthDateNotChecked}</span>;
}
